import React, { useEffect, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { get } from 'lodash';

import { downloadCheckList, toggleCheckedCheckListItem } from '../../../actions/checkList';
import { NotificationTypes, pushNotification } from '../../../actions/notifications';
import { getCurrentCheckLists } from '../../../selectors/checkList';
import { getCrewTypeSelector, useCurrentLeg } from '../../../selectors/screen';

export const useCheckListModalContent = () => {
    const crewType = useSelector(getCrewTypeSelector);
    const { checkInfoShowed, currentCheckListId, currentItemId } = useSelector((state) => {
        const checkInfoShowed = get(state, 'checkLists.checkInfoShowed', false);
        const { checkListId, itemId } = get(state, 'checkLists.currentCheckList', {});

        return {
            checkInfoShowed,
            currentCheckListId: checkListId,
            currentItemId: itemId,
        };
    });

    const checkLists = useSelector(getCurrentCheckLists) || {};
    const currentLeg = useCurrentLeg();
    const { t: translate } = useTranslation();
    const initCheckListID =
        Object.keys(checkLists).length > 0
            ? currentCheckListId && Object.keys(checkLists).includes(currentCheckListId)
                ? currentCheckListId
                : Object.keys(checkLists)[0]
            : null;

    const [checkListId, changeCheckListId] = React.useState(initCheckListID);

    const dispatch = useDispatch();

    const handleToggleCheckItem = React.useCallback((itemId) => dispatch(toggleCheckedCheckListItem(checkListId, itemId)), [checkListId]);

    const handleDownloadCheckList = React.useCallback(() => {
        dispatch(downloadCheckList(currentLeg, crewType));
    }, [currentLeg, crewType]);

    useEffect(() => {
        if (checkInfoShowed) {
            return;
        }

        dispatch(
            pushNotification({
                variant: NotificationTypes.INFO,
                message: translate('messages.swipeToChangeStatus'),
                details: '',
            })
        );
    }, [checkInfoShowed]);

    useLayoutEffect(() => {
        const elem = document.getElementById(`${currentItemId}`);
        if (elem) {
            elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [currentItemId]);

    const handleCheckListChange = React.useCallback((event, newValue) => changeCheckListId(newValue), []);

    return { checkListId, checkLists, handleDownloadCheckList, handleToggleCheckItem, handleCheckListChange };
};
